export const SET_INITIAL_EFORMS = 'SET_INITIAL_EFORMS'
export const SET_INITIAL_TOTAL = 'SET_INITIAL_TOTAL'
export const ADD_ADITIONAL_EFORMS = "ADD_ADITIONAL_EFORMS"
export const SET_EFORM_TEMPLATES = "SET_EFORM_TEMPLATES"
export const CHANGE_EFORMS = 'CHANGE_EFORMS'
export const SET_EFORM_SELECTED = 'SET_EFORM_SELECTED'
export const SET_INITIAL_FOLDERS = 'SET_INITIAL_FOLDERS'
export const SET_ENABLE_PICKUP = 'SET_ENABLE_PICKUP'
export const DELETE_PICKUP = 'DELETE_PICKUP'
export const EDIT_PICKUP = 'EDIT_PICKUP'
export const SET_INITIAL_EFORM_JWT = 'SET_INITIAL_EFORM_JWT'
export const SET_INITIAL_EFORM_CREATE = 'SET_INITIAL_EFORM_CREATE'
export const UPDATE_NONPICKUP_EFORM = 'UPDATE_NONPICKUP_EFORM'
export const SET_INITIAL_EFORM_AUTOCOMPLETE = 'SET_INITIAL_EFORM_AUTOCOMPLETE'
export const SET_INITIAL_URL_S3 = 'SET_INITIAL_URL_S3'
export const SET_INITIAL_EFORM_PAIS = 'SET_INITIAL_EFORM_PAIS'
